import moment from 'moment';

export function getTimeOfDayNotification(job) {
	const { duration, startTime, endTime } = job;
	const start = moment(startTime).hours() + moment(startTime).minutes() / 60;
	const end = moment(endTime).hours() + moment(endTime).minutes() / 60;
	const startTimeShift = moment(startTime).format('HH:mm');
	const endTimeShift = moment(endTime).format('HH:mm');

	let dayDuration = duration;
	let nightDuration = 0;
	if (end < start) {
	  nightDuration = Math.min(end, 4) - Math.max(start - 24, -4);
	  dayDuration = duration - nightDuration;
	} else {
	  dayDuration = Math.min(end, 20) - Math.max(start, 4);
	  nightDuration = duration - dayDuration;
	}

	const timeDay = dayDuration >= nightDuration ? 'Day' : 'Night';
	const durationTimeWork = `${startTimeShift}-${endTimeShift}`;
	return { timeDay, durationTimeWork };
}
